<template>
  <div class="detacon">
    <van-nav-bar
      :title="$t('m.lc_span0')"
      @click-left="fanhui"
      left-arrow
    ></van-nav-bar>

    <div
      v-if="!productLoaded && !productLoadFailed"
      class="product-detail-loading"
      aria-live="polite"
      aria-label="产品详情加载中"
    >
      <div class="loading-card">
        <span class="loading-line loading-title"></span>
        <div class="loading-summary">
          <span class="loading-line loading-rate"></span>
          <span class="loading-line loading-cycle"></span>
        </div>
        <span class="loading-line loading-progress"></span>
      </div>
      <div class="loading-card loading-detail-card">
        <span class="loading-line loading-heading"></span>
        <span class="loading-line"></span>
        <span class="loading-line loading-short"></span>
      </div>
    </div>

    <div v-else-if="productLoadFailed" class="product-load-error">
      <p>产品信息加载失败</p>
      <button type="button" @click="loadProduct">重新加载</button>
    </div>

    <div v-else class="productSort_con_list">
      <div style="padding: 0 10px">
        <div
          class="productSort_block"
          style="border-radius: 8px; margin-top: 46px"
        >
          <div class="productSort_block_left">
            <p class="productSort_block_left_xh">{{ dicdata.title }}</p>
          </div>
          <div class="productSort_block_last">
            <div class="productSort_block_last_item" style="width: 50%">
              <p
                class=""
                style="
                  font-size: 20px;
                  font-weight: bold;
                  color: var(--bg-color);
                  margin-bottom: 6px;
                  height: 30px;
                  line-height: 30px;
                "
              >
                {{ formatPercent(dicdata.rate) }}%
              </p>
              <p class="" style="font-size: 12px; color: #999">
                {{ $t("m.rishouyi") }}
              </p>
            </div>
            <div class="productSort_block_last_item product-summary-side">
              <p class="product-summary-row">
                <span class="product-summary-label">投资周期</span>
                <span class="product-summary-value"
                  >{{ dicdata.day }}{{ $t("m.lc_span23") }}</span
                >
              </p>
              <p class="product-summary-row">
                <span class="product-summary-label">剩余金额</span>
                <span
                  class="product-summary-value product-summary-amount"
                  :class="amountLengthClass(shengxia)"
                  >{{ formatAmount(shengxia) }}</span
                >
              </p>
            </div>
          </div>
          <div
            style="display: flex; align-items: center; padding: 9px"
            class="fengxian1"
          >
            <span>{{ dicdata.tag }}</span>
            <span>{{ $t("m.lc_span24") }}</span>
            <span v-show="dicdata.added > 0">增值收益</span>
            <span>{{ formatAmount(dicdata.min) }}{{ $t("m.qitou") }}</span>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 20px;
              padding: 0 9px;
            "
          >
            <span style="color: #999; width: 60px; font-size: 12px"
              >{{ $t("m.lc_span28") }}：</span
            >
            <div
              style="
                width: 60%;
                height: 6px;
                background-color: #f3f0f6;
                border-radius: 6px;
              "
            >
              <div
                style="
                  background-color: var(--bg-color);
                  height: 100%;
                  border-radius: 6px;
                "
                :style="{ width: dicdata.schedule + '%' }"
              ></div>
            </div>
            <span style="font-size: 12px; color: #666; margin-left: 10px"
              >{{ formatPercent(dicdata.schedule) }}%</span
            >
          </div>
        </div>
      </div>

      <div style="padding: 0">
        <van-tabs swipeable animated>
          <van-tab :label="$t('m.hz_span19')" title="产品详情">
            <div class="project-detail-wrap">
              <section class="project-intro-card">
                <div class="detail-section-heading">
                  <span></span>
                  <div>
                    <small>PROJECT OVERVIEW</small>
                    <h2>项目介绍</h2>
                  </div>
                </div>
                <p class="project-intro-text">{{ projectDescription }}</p>
                <div class="project-code">
                  <span>项目编号</span>
                  <strong>{{ dicdata.code || "--" }}</strong>
                </div>
              </section>

              <section class="project-detail-card">
                <div class="detail-section-heading compact">
                  <span></span>
                  <div>
                    <small>KEY INFORMATION</small>
                    <h2>核心要素</h2>
                  </div>
                </div>
                <div class="project-facts">
                  <div>
                    <span>项目类型</span>
                    <strong>{{ normalizedProductType }}</strong>
                  </div>
                  <div>
                    <span>投资周期</span>
                    <strong>{{ dicdata.day || 0 }} 天</strong>
                  </div>
                  <div>
                    <span>起投金额</span>
                    <strong>{{ formatAmount(dicdata.min) }} USD</strong>
                  </div>
                  <div>
                    <span>返利方式</span>
                    <strong>{{ repaymentMethod }}</strong>
                  </div>
                  <div>
                    <span>募集规模</span>
                    <strong>{{ formatAmount(dicdata.price) }} USD</strong>
                  </div>
                  <div>
                    <span>当前进度</span>
                    <strong>{{ formatPercent(dicdata.schedule) }}%</strong>
                  </div>
                </div>
              </section>

              <section class="project-detail-card settlement-card">
                <div class="detail-section-heading compact">
                  <span></span>
                  <div>
                    <small>RETURN &amp; SETTLEMENT</small>
                    <h2>收益与结算</h2>
                  </div>
                </div>
                <div class="settlement-highlight">
                  <div>
                    <span>参考日收益率</span>
                    <strong>{{ formatPercent(dicdata.rate) }}%</strong>
                  </div>
                  <div>
                    <span>限投次数</span>
                    <strong>{{ dicdata.mcount || 0 }} 次</strong>
                  </div>
                </div>
                <p>
                  {{ settlementDescription }}
                </p>
                <div class="guarantee-row" v-if="dicdata.company">
                  <span>合作机构</span>
                  <strong>{{ dicdata.company.name }}</strong>
                </div>
              </section>

              <aside class="project-risk-note">
                <strong>本金及约定收益保障</strong>
                <p>购买成功后系统将为本笔产品生成独立电子合同，并关联本人电子签名。合同完整展示本金、收益率、保障期限、结算方式、双方义务、违约责任及到期权益，可在“我的产品”中随时查看。</p>
              </aside>
            </div>
          </van-tab>
          <van-tab :label="$t('m.hz_span24')" title="收益计算">
            <div style="padding: 0 10px">
              <div class="detacon_quxian" style="margin-top: 10px">
                <p style="text-align: left" class="">{{ $t("m.lc_span6") }}</p>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    font-size: 13px;
                    justify-content: space-between;
                  "
                >
                  <div
                    style="
                      background: var(--bg-color);
                      border-radius: 4px;
                      width: 8px;
                      height: 8px;
                      position: relative;
                    "
                  >
                    <div
                      style="
                        position: absolute;
                        top: 18px;
                        left: 0;
                        width: 70px;
                        color: #666;
                        text-align: left;
                        font-size: 10px;
                      "
                    >
                      <span style="display: block; color: #000">
                        {{ $t("m.lc_span7") }}
                      </span>
                      <span style="color: #666">{{ $t("m.lc_span10") }}</span>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      height: 2px;
                      background-color: var(--bg-color);
                    "
                  ></div>
                  <div
                    style="
                      background: var(--bg-color);
                      border-radius: 4px;
                      width: 8px;
                      height: 8px;
                      position: relative;
                    "
                  >
                    <div
                      style="
                        position: absolute;
                        top: 18px;
                        left: -31px;
                        width: 70px;
                        color: #666;
                        text-align: center;
                        font-size: 10px;
                      "
                    >
                      <span style="display: block; color: #000">{{
                        $t("m.lc_span8")
                      }}</span>
                      <span style="color: #666">{{ $t("m.lc_span11") }}</span>
                    </div>
                  </div>
                  <div
                    style="
                      flex: 1;
                      height: 2px;
                      background-color: var(--bg-color);
                      position: relative;
                    "
                  >
                    <div
                      style="
                        position: absolute;
                        top: 14px;
                        right: -16px;
                        width: 90px;
                        color: #666;
                        text-align: right;
                        font-size: 10px;
                      "
                    >
                      <span style="display: block; color: #000">{{
                        $t("m.lc_span9")
                      }}</span>
                      <span style="color: #666">{{ $t("m.lc_span12") }}</span>
                    </div>
                  </div>
                  <div
                    style="
                      background: var(--bg-color);
                      border-radius: 4px;
                      width: 8px;
                      height: 8px;
                      position: relative;
                    "
                  ></div>
                </div>
                <div
                  style="
                    margin-top: 60px;
                    font-size: 15px;
                    color: #000;
                    width: 100%;
                    line-height: 30px;
                  "
                >
                  <!--                  {{ dicdata.min }}*{{ dicdata.rate }}%*-->
                  <!--                  {{ dicdata.day }}-->
                  <!--                  {{ guo > 0 ? "+" + guo : ""}}-->
                  <!--                  {{ hong > 0 ? "+" + hong : "" }}={{ zhi }}-->
                </div>
                <div
                  class="desc-sll"
                  style="margin-top:60px;font-size:15px;color:#000;width: 100%;line-height:30px;"
                >
                  <p>
                    1.USD收益：{{ formatAmount(dicdata.min) }}*（{{
                      formatPercent(baseProductRate)
                    }}%+{{
                      formatPercent(vipBonusRate)
                    }}%）*{{ dicdata.day }}={{
                      formatAmount(basePeriodIncome)
                    }} USD
                  </p>
                  <p>2.返利方式：{{ repaymentMethod }}</p>
                  <p>3.产品周期：{{ dicdata.day }} 天</p>
                  <p v-if="jhong > 0">
                    4.建仓红包：固定 {{ formatAmount(jhong) }} USD，购买成功后立即赠送至账户可提现余额。
                  </p>
                  <p>
                    {{ calculationRuleNumber }}.返利计算：以参与金额{{ formatAmount(dicdata.min) }} USD计算，本金{{
                      formatAmount(dicdata.min)
                    }}
                    USD*（日化回报率{{
                      formatPercent(baseProductRate)
                    }}%+会员叠加利率{{
                      formatPercent(vipBonusRate)
                    }}%）*产品周期{{ dicdata.day }}天{{
                      addedIncome > 0 ? "+增值收益" + formatAmount(addedIncome) + " USD" : ""
                    }}=收益{{ formatAmount(expectedIncome) }} USD+本金{{
                      formatAmount(dicdata.min)
                    }} USD=到期合计收益{{ formatAmount(maturityAmount) }} USD
                  </p>
                  <p>
                    {{ settlementRuleNumber }}.结算时间：参与成功后按产品约定方式开始计算。选择按日返息的产品，每满24小时返息至账户余额；选择到期返本返息的产品，在第{{
                      dicdata.day
                    }}个产品日统一结算本金与返利至平台账户。
                  </p>
                  <p>
                    {{ participationRuleNumber }}.参与规则：募集期间产品额度充足时可多次参与，当前产品限购{{
                      dicdata.mcount
                    }}次
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab :label="$t('m.lc_span6')" title="常见问题">
            <div style="padding: 0 10px">
              <div
                class="product_tags detacon_quxian"
                style="background: #fff; margin-top: 10px"
              >
                <div class="tags_title leftgo">{{ $t("m.lc_span13") }}</div>
                <div :class="q_hide == 1 ? 'ques' : 'ques q_hide'">
                  <div class="ques_title" @click="toggle_ques(1)">
                    <span>{{ $t("m.lc_span14") }}</span>
                    {{ $t("m.lc_span16") }}
                    <img src="../../assets/images/new/xljt.png" alt="" />
                  </div>
                  <div class="ques_answer">
                    <span>{{ $t("m.lc_span15") }}</span>
                    {{ $t("m.lc_span17") }}
                  </div>
                </div>
                <div :class="q_hide == 2 ? 'ques' : 'ques q_hide'">
                  <div class="ques_title" @click="toggle_ques(2)">
                    <span>{{ $t("m.lc_span14") }}</span>
                    {{ $t("m.lc_span18") }}
                    <img src="../../assets/images/new/xljt.png" />
                  </div>
                  <div class="ques_answer">
                    <span>{{ $t("m.lc_span15") }}</span>
                    {{ $t("m.lc_span19") }}
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>

      <!-- <div class="detacon_quxian" style="margin-top:10px;">
        <p style="text-align:left;" class="">常见问题</p>
        <div>
            <div style="display:flex;align-items:center;">
              <span style="width: 26px;line-height:26px;border-radius:50%;background:#007aff;">问</span>
              <span style="font">该产品气息、到账规则是什么？</span>
            </div>
        </div>
      </div> -->
      <div style="padding: 0 20px">
        <div class="detacon_xq" v-if="isProjectUnavailable(dicdata)">
          <div
            @click="details(dicdata.id)"
            :style="{
              background: isProjectUnavailable(dicdata)
                ? '#dfdfdf'
                : 'var(--bg-color)'
            }"
            style="
              text-align: center;
              height: 44px;
              line-height: 44px;
              color: #fff;
              font-weight: bold;
            "
          >
            {{ projectActionText(dicdata) }}
          </div>
        </div>
        <div style="display: flex; align-items: center" v-else>
          <div
            @click="details(dicdata.id, 0)"
            style="
              flex: 1;
              margin-top: 30px;
              border-radius: 8px;
              line-height: 40px;
              text-align: center;
              font-size: 15px;
              font-weight: bold;
              color: #fff;
              background: var(--bg-color);
            "
          >
            {{ $t("m.hz_span11") }}
          </div>
        </div>
      </div>

      <div style="height: 90px; width: 100%"></div>
    </div>
  </div>
</template>
<script>
import request from "@utils/request";
let NAME = "GoodsCon";
export default {
  name: NAME,
  components: {},
  data: function() {
    return {
      q_hide: 1,
      guo: 0,
      hong: 0,
      zhi: 0,
      jguo: 0,
      jhong: 0,
      jzhi: 0,
      pczj: 0,
      shengxia: "",
      image: require("@assets/images/licai/datou.png"),
      images: [
        require("@assets/images/bank/f1.jpg"),
        require("@assets/images/bank/f2.jpg"),
        require("@assets/images/bank/f0.jpg"),
        require("@assets/images/bank/f4.jpg"),
        require("@assets/images/bank/f5.jpg"),
        require("@assets/images/bank/f6.jpg"),
        require("@assets/images/bank/f7.jpg"),
        require("@assets/images/bank/f8.jpg"),
        require("@assets/images/bank/f9.jpg"),
        require("@assets/images/bank/f3.jpg")
      ],
      dicdata: { schedule: 0 },
      shareInfoStatus: false,
      weixinStatus: false,
      mapShow: false,
      mapKey: "",
      posterData: {
        image: "",
        title: "",
        price: "",
        code: ""
      },
      days: "",
      type: null,
      productLoaded: false,
      productLoadFailed: false
    };
  },

  computed: {
    baseProductRate() {
      return Number(this.dicdata.rate || 0);
    },
    vipBonusRate() {
      return Math.max(0, Number(this.dicdata.vip_rate || 0));
    },
    effectiveDailyRate() {
      return this.baseProductRate + this.vipBonusRate;
    },
    basePeriodIncome() {
      return (
        Number(this.dicdata.min || 0) *
        this.effectiveDailyRate *
        0.01 *
        Number(this.dicdata.day || 0)
      );
    },
    addedIncome() {
      return this.basePeriodIncome * Number(this.dicdata.added || 0) * 0.01;
    },
    expectedIncome() {
      return this.basePeriodIncome + this.addedIncome;
    },
    maturityAmount() {
      return Number(this.dicdata.min || 0) + this.expectedIncome;
    },
    hasFixedGift() {
      return Number(this.dicdata.gift_fixed || 0) > 0;
    },
    calculationRuleNumber() {
      return this.hasFixedGift ? 5 : 4;
    },
    settlementRuleNumber() {
      return this.hasFixedGift ? 6 : 5;
    },
    participationRuleNumber() {
      return this.hasFixedGift ? 7 : 6;
    },
    normalizedProductType() {
      if (Number(this.dicdata.project_type) === 2) {
        return "研发专区";
      }
      if (Number(this.dicdata.project_type) === 1) {
        return "分红型";
      }
      const tag = String(this.dicdata.tag || "");
      if (/股票|混合|债券|IPO|证券/i.test(tag)) {
        return "定返分红型";
      }
      return tag || "定返分红型";
    },
    repaymentMethod() {
      const value = String(this.dicdata.payment_desc || "");
      if (/到期.*本.*息|本息.*到期/.test(value)) {
        return "到期返本返息";
      }
      if (/按天|按日|每日/.test(value)) {
        return "按日返息，到期返本";
      }
      return value || "按日返息，到期返本";
    },
    settlementDescription() {
      return this.repaymentMethod === "到期返本返息"
        ? "产品周期内按约定比例累计返利，到期后本金与返利一次性结算至账户。"
        : "返利按日结算至账户，产品到期后本金自动返还至账户。";
    },
    projectDescription() {
      const description = String(this.dicdata.desc || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim();
      if (description) {
        return description;
      }
      const title = String(this.dicdata.title || "本项目").trim();
      const tag = this.normalizedProductType;
      const day = this.dicdata.day || 0;
      return `${title}为${tag}产品，产品周期为${day}天，采用“${this.repaymentMethod}”方式。购买后自动生成含本人电子签名的本金及约定收益保障合同，可在每笔已购产品中查看返利记录、合同权益和保障期限。`;
    }
  },

  watch: {},
  updated() {
    // window.scroll(0, 0);
  },
  mounted: function() {
    var myDate = new Date();
    let yue = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    let ri = myDate.getDate(); //获取当前日(1-31)
    if (yue < 10) {
      yue = "0" + yue;
    }
    if (ri < 10) {
      ri = "0" + ri;
    }
    this.days = yue + "-" + ri;

    let type = this.$route.params.id;
    this.type = type;
    console.log("传参");
    console.log(type);
    this.loadProduct();
  },
  methods: {
    loadProduct() {
      const type = this.type || this.$route.params.id;
      this.type = type;
      this.productLoaded = false;
      this.productLoadFailed = false;
      request
        .get("/fund/project/detail", { id: type }, { login: false })
        .then(res => {
          this.dicdata = res.data.data;
          this.shengxia = (
            (parseFloat(this.dicdata.price) * (100 - this.dicdata.schedule)) /
            100
          ).toFixed(2);
          if (this.dicdata.added > 0) {
            this.guo = (
              ((this.dicdata.min * this.dicdata.rate) / 100) *
              this.dicdata.day *
              (this.dicdata.added / 100)
            ).toFixed(2);
            this.jguo = (
              ((this.dicdata.min *
                this.effectiveDailyRate) /
                100) *
              this.dicdata.day *
              (this.dicdata.added / 100)
            ).toFixed(2);
          }
          if (Number(this.dicdata.gift_fixed) > 0) {
            this.hong = Number(this.dicdata.gift_fixed).toFixed(2);
            this.jhong = Number(this.dicdata.gift_fixed).toFixed(2);
          }
          this.dicdata.rate = Number(this.dicdata.rate);
          this.zhi =
            parseFloat(
              (
                this.dicdata.min *
                (
                  parseFloat(this.dicdata.rate) +
                  parseFloat(this.dicdata.vip_rate || 0)
                ).toFixed(2) *
                0.01 *
                this.dicdata.day
              ).toFixed(2)
            ) +
            parseFloat(this.guo || 0);
          console.log("-> this.dicdata.rate", this.dicdata.rate);
          console.log("-> this.dicdata.min", this.dicdata.min);
          console.log("-> this.zhi", this.zhi);
          this.jzhi =
            parseFloat(
              (
                this.dicdata.min *
                this.effectiveDailyRate *
                0.01 *
                this.dicdata.day
              ).toFixed(2)
            ) +
            parseFloat(this.jguo || 0);
          console.log("-> this.jzhi", this.jzhi);
          this.pczj = parseFloat(this.dicdata.min) + this.jzhi;
          console.log("-> this.pczj", this.pczj);
          this.productLoaded = true;

          // this.dicdata = res.data.data;
          //   this.dicdata.rateh = (
          //     Number(this.dicdata.rate) + Number(this.dicdata.vip_rate || 0)
          //   ).toFixed(3);
          //   console.log("-> this.dicdata", this.dicdata);
          //   this.dicdata.schedule = Number(this.dicdata.schedule || 0).toFixed(3);
          //   this.shengxia = (
          //     (parseFloat(this.dicdata.price) * (100 - this.dicdata.schedule)) /
          //     100
          //   ).toFixed(0);
          //   if (this.dicdata.additional == 1) {
          //     this.guo = (
          //       (this.dicdata.min *
          //         this.dicdata.rateh *
          //         0.01 *
          //         this.dicdata.day) /
          //       2
          //     ).toFixed(2);
          //     console.log("-> this.guo", this.guo);
          //   }
          //   this.zhi =
          //     parseFloat(
          //       (
          //         this.dicdata.min *
          //         this.dicdata.rateh *
          //         0.01 *
          //         this.dicdata.day
          //       ).toFixed(2)
          //     ) +
          //     parseFloat(this.guo) +
          //     parseFloat(this.hong);
          //   console.log("-> this.zhi", this.zhi);
          // })
          // .catch(err => {
          //   console.log(err);
        })
        .catch(() => {
          this.productLoadFailed = true;
        });
    },
    amountLengthClass(value) {
      const amount = this.formatAmount(value);
      if (amount.length >= 13) {
        return "is-extra-long";
      }
      if (amount.length >= 10) {
        return "is-long";
      }
      return "";
    },
    formatAmount(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value || "0.00";
      }
      return num.toFixed(2);
    },
    formatPercent(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value || "0.00";
      }
      return num.toFixed(2);
    },
    toggle_ques(index) {
      this.q_hide = index;
    },
    isProjectFull(item) {
      if (!item) {
        return false;
      }
      return Number(item.status) == 2 || Number(item.schedule) >= 100;
    },
    isProjectNotStarted(item) {
      return item && Number(item.status) == 0;
    },
    isProjectUnavailable(item) {
      return this.isProjectNotStarted(item) || this.isProjectFull(item);
    },
    projectActionText(item) {
      if (this.isProjectNotStarted(item)) {
        return "未开启";
      }
      return this.isProjectFull(item) ? this.$t("m.lc_span30") : this.$t("m.hz_span11");
    },
    details: function(e, t) {
      if (this.isProjectNotStarted(this.dicdata)) {
        this.$dialog.message("项目未开启");
        return;
      }
      if (this.isProjectFull(this.dicdata)) {
        this.$dialog.message("项目已满仓");
        return;
      }
      localStorage.setItem("zhonglei", 0);
      this.$router.push({
        path: "/pay/" + e
      });
    },
    fanhui: function() {
      this.$router.go(-1);
    },
    juti: function() {
      this.$router.push({
        path: "/shop/touZiList"
      });
    }
  },
  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped lang="less">
/deep/ .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
/deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-nav-bar__title {
  color: #fff;
}
/deep/ .van-icon {
  color: #fff;
}
.detacon {
  min-height: 100vh;
  background-color: #f2f1f6;
}
.product-detail-loading,
.product-load-error {
  min-height: calc(100vh - 46px);
  padding: 61px 10px 20px;
  background-image: url(../../assets/images/bg/user_bank.png);
  background-repeat: no-repeat;
  background-size: 100% 175px;
  box-sizing: border-box;
}
.loading-card {
  margin-bottom: 10px;
  padding: 22px 19px;
  background: #fff;
  border-radius: 8px;
}
.loading-detail-card {
  margin-top: 16px;
  border-radius: 14px;
}
.loading-line {
  display: block;
  width: 100%;
  height: 12px;
  margin-bottom: 14px;
  overflow: hidden;
  background: linear-gradient(90deg, #edf0f4 25%, #f7f8fa 37%, #edf0f4 63%);
  background-size: 400% 100%;
  border-radius: 6px;
  animation: product-loading 1.4s ease infinite;
}
.loading-title {
  width: 58%;
  height: 15px;
}
.loading-summary {
  display: flex;
  justify-content: space-between;
  margin: 25px 0 18px;
}
.loading-summary .loading-line {
  margin-bottom: 0;
}
.loading-rate {
  width: 30%;
  height: 26px;
}
.loading-cycle {
  width: 38%;
  height: 26px;
}
.loading-progress {
  width: 80%;
  height: 7px;
  margin-bottom: 0;
}
.loading-heading {
  width: 35%;
  height: 18px;
}
.loading-short {
  width: 72%;
  margin-bottom: 0;
}
.product-load-error {
  padding-top: 105px;
  color: #65758a;
  text-align: center;
}
.product-load-error p {
  margin-bottom: 18px;
  font-size: 14px;
}
.product-load-error button {
  padding: 9px 24px;
  color: #fff;
  font-size: 14px;
  background: var(--bg-color);
  border: 0;
  border-radius: 20px;
}
@keyframes product-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.detacon_quxian {
  border-radius: 8px;
  padding: 15px;
  background-color: #ffffff;
}
.detacon_quxian img {
  width: 100%;
}

.project-detail-wrap {
  padding: 10px;
}

.project-intro-card,
.project-detail-card {
  margin-bottom: 10px;
  padding: 20px 18px;
  background: #fff;
  border: 1px solid #edf1f6;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(18, 54, 96, 0.05);
}

.project-intro-card {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 100% 0, rgba(42, 126, 205, 0.1), transparent 34%),
    #fff;
}

.detail-section-heading {
  display: flex;
  align-items: center;
  margin-bottom: 17px;
}

.detail-section-heading > span {
  width: 4px;
  height: 35px;
  margin-right: 10px;
  background: linear-gradient(180deg, #0b4f9f, #2c8bd2);
  border-radius: 4px;
}

.detail-section-heading small,
.detail-section-heading h2 {
  display: block;
  margin: 0;
}

.detail-section-heading small {
  color: #8b9aaf;
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 1.2px;
}

.detail-section-heading h2 {
  margin-top: 3px;
  color: #192d49;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
}

.detail-section-heading.compact {
  margin-bottom: 14px;
}

.detail-section-heading.compact > span {
  height: 30px;
}

.detail-section-heading.compact h2 {
  font-size: 16px;
}

.project-intro-text {
  margin: 0;
  color: #52637a;
  font-size: 14px;
  font-weight: 400;
  line-height: 2;
  text-align: justify;
  white-space: pre-line;
  word-break: break-word;
}

.project-code {
  display: flex;
  align-items: center;
  margin-top: 17px;
  padding-top: 14px;
  border-top: 1px dashed #dfe6ef;
}

.project-code span {
  color: #8a97a9;
  font-size: 12px;
}

.project-code strong {
  margin-left: auto;
  color: #294460;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.project-facts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}

.project-facts > div {
  min-width: 0;
  padding: 13px 12px;
  background: #f7f9fc;
  border: 1px solid #edf1f6;
  border-radius: 10px;
}

.project-facts span,
.project-facts strong {
  display: block;
}

.project-facts span {
  margin-bottom: 7px;
  color: #8a97a9;
  font-size: 11px;
}

.project-facts strong {
  overflow: hidden;
  color: #243852;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.settlement-highlight {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 14px;
}

.settlement-highlight > div {
  padding: 12px;
  background: #f1f7fd;
  border-radius: 10px;
}

.settlement-highlight span,
.settlement-highlight strong {
  display: block;
}

.settlement-highlight span {
  margin-bottom: 5px;
  color: #708198;
  font-size: 11px;
}

.settlement-highlight strong {
  color: #176fc0;
  font-size: 17px;
  font-weight: 700;
}

.settlement-card > p {
  margin: 0;
  color: #5b6b7f;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.9;
}

.guarantee-row {
  display: flex;
  align-items: flex-start;
  margin-top: 14px;
  padding-top: 13px;
  border-top: 1px solid #edf1f6;
}

.guarantee-row span {
  flex: 0 0 auto;
  color: #8a97a9;
  font-size: 12px;
}

.guarantee-row strong {
  margin-left: auto;
  padding-left: 16px;
  color: #314760;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  text-align: right;
}

.project-risk-note {
  margin-bottom: 10px;
  padding: 15px 16px;
  background: #edf5fb;
  border: 1px solid #d9e8f3;
  border-radius: 12px;
}

.project-risk-note strong {
  display: block;
  margin-bottom: 7px;
  color: #9a641a;
  font-size: 13px;
}

.project-risk-note p {
  margin: 0;
  color: #856d4c;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.8;
}
.detacon_xq {
  overflow: hidden;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin-top: 30px;
  border-radius: 8px;
}
.detacon_quxian p {
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000;
  line-height: 20px;
}
.detacon_wai {
  padding: 0 15px;
}
.detacon_con_bot {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.detacon_con_bot_block {
  flex: 1;
}
.detacon_con_bot_block p:first-child {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  opacity: 0.5;
  text-align: center;
}
.detacon_con_bot_block p:last-child {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
}
.detacon_con {
  background-color: #ffffff;
  padding: 20px 15px;
}
.detacon_con_top {
  display: flex;
  align-items: center;
  padding: 15px;
}
.detacon_con_top_left_tit {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #100d0d;
  line-height: 35px;
}
.detacon_con_top_left_txt {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #100d0d;
  line-height: 35px;
}
.detacon_con_top_right {
  margin-left: auto;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1664fc;
  line-height: 36px;
}
.jiangli_top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
.jiangli_top img {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 0px;
}
.jiangli_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
}

.productSort_block_left_xh {
  /* max-width: 260px; */

  /* margin-bottom: 5px; */
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.productSort_block_left_dm {
  border: 1px solid red;
  color: red;
  padding: 1px 4px;
  border-radius: 4px;
  margin-left: 10px;
  font-size: 10px;
}
.fengxian1 span {
  border: 0.5px solid var(--bg-color);
  color: var(--bg-color);
  padding: 2px 4px;
  border-radius: 4px;
  margin-right: 10px;
  font-size: 9px;
}
.fengxian12 span {
  color: #fff;
  background: var(--bg-color);
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 10px;
  font-size: 12px;
}
.productSort_block_last {
  padding: 0px 9px;
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}
.productSort_block_last_item {
  min-width: 0;
}
.productSort_block_last_item:last-child {
  margin-left: 0px;
}
.product-summary-side {
  width: 50%;
  padding-left: 6px;
  box-sizing: border-box;
}
.product-summary-row {
  display: flex;
  align-items: baseline;
  min-width: 0;
  height: 30px;
  margin: 0 0 6px;
  color: var(--bg-color);
  line-height: 30px;
  white-space: nowrap;
}
.product-summary-row:last-child {
  margin-bottom: 0;
}
.product-summary-label {
  flex: 0 0 58px;
  color: #999;
  font-size: 12px;
}
.product-summary-value {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 15px;
  font-weight: bold;
  color: var(--bg-color);
}
.product-summary-amount {
  transform-origin: left center;
}
.product-summary-amount.is-long {
  font-size: 13px;
}
.product-summary-amount.is-extra-long {
  font-size: 12px;
}
.productSort_block_left {
  display: flex;
  align-items: center;
  padding-left: 9px;
  margin-bottom: 6px;
}
.productSort_con_list {
  margin-top: -46px;
  padding: 15px 0px;
  background-image: url(../../assets/images/bg/user_bank.png);
  background-repeat: no-repeat;
  background-size: 100% 175px;
}
.productSort_block {
  position: relative;

  width: 100%;
  background-color: #ffffff;
  padding: 20px 10px;
  margin-bottom: 10px;
}
.productSort_block img {
  width: 100%;
  height: 86px;
}
.productSort_top {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 0 6px;
  /* justify-content: space-between; */
}
.productSort_top_block {
  flex-shrink: 0;

  display: inline-block;
  margin-right: 14px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  text-align: center;
}

.productSort_top_blocks {
  border-bottom: 2px solid #007aff;
  color: #007aff;
}

.product_tags {
  padding: 30rpx 28rpx;
  display: flex;
  flex-direction: column;
}

.tags_title {
  font-size: 32rpx;
  font-weight: 500;
  margin-bottom: 20rpx;
  color: #333;
  display: flex;
  justify-content: space-around;
}

.tags_title view {
  width: 184rpx;
  height: 45rpx;
  font-family: PingFang;
  font-weight: bold;
  color: #999999;
  text-align: center;
  position: relative;
}

.leftgo {
  justify-content: left;
}

.tag_active {
  color: #1769b0 !important;
}

.active_line {
  width: 45rpx !important;
  height: 4rpx !important;
  background: #1769b0;

  position: absolute;
  bottom: -10rpx;
  left: 65rpx;
}

.tags_item_wrap {
  display: flex;
  align-items: center;

  width: 80rpx;
}

.tags_item_wrap.left {
  float: left;
}

.tags_item_wrap.right {
  float: right;
}

.tags_item_wrap image {
  width: 80rpx;
  height: 80rpx;
  margin: 0 auto;
  display: block;
}

.tags_item {
  font-size: 25rpx;
  font-weight: 500;
}

.tags_item_title {
  align-items: center;
  display: flex;
}

.tags_item_title text {
  color: #101422;
  font-size: 18rpx;
  margin-right: 8rpx;
}

.tags_content {
  color: #999999;
  margin-top: 10rpx;
  font-size: 23rpx;
  font-weight: 500;
}

.product_info {
  display: none;
  flex-direction: column;
  font-size: 28rpx;
}

.show {
  display: flex;
}

.info_clomun {
  display: flex;
  line-height: 60rpx;
  border-bottom: #e5e5e5 1rpx solid;
}

.cloumn_title {
  margin-right: 20rpx;
  padding: 15rpx 26rpx;
  width: 16%;
  color: #999999;
}

.cloumn_content {
  padding: 15rpx 28rpx 0;
  text-align: left;
  width: 70%;
}

.cloumn_content_gz {
  padding: 15rpx 26rpx;
  color: rgba(51, 51, 51, 0.7);
  width: 100%;
}

.invest_desc {
  width: 100%;
  height: 185rpx;
  display: none;
}

.shows {
  display: block;
}

.ques {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  border-bottom: 1px solid rgba(51, 51, 51, 0.1);
}

.ques_title {
  color: rgba(51, 51, 51, 1);
  padding: 15px 0;
}

.ques_title span {
  display: inline-block;
  width: 25px;
  height: 25px;
  background: var(--bg-color);
  font-weight: bold;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  margin-right: 13px;
  color: #ffffff;
}

.ques_answer span {
  display: inline-block;
  width: 25px;
  height: 25px;
  background: #fe98b1;
  font-weight: bold;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  margin-right: 13px;
  color: #ffffff;
}

.ques_title img {
  width: 18px;
  height: 15px;
  opacity: 0.6;
  float: right;
  position: relative;
  top: 10px;
  display: none;
}

.ques_answer {
  font-weight: 400;
  color: rgba(51, 51, 51, 0.7);
  border-radius: 50%;
  margin-bottom: 10px;
  position: relative;
  top: -14rpx;
  line-height: 22px;
}

.q_hide .ques_answer {
  display: none;
}

.q_hide img {
  display: block;
}

.bottom_wrap {
  width: 100%;
  font-weight: 400;
  color: #999999;
  font-size: 26rpx;
  background-color: rgb(244, 245, 247);
  padding: 35rpx 0 40rpx;
  padding-left: 20rpx;
  box-sizing: border-box;
}

.buynow {
  width: 90%;
  height: 90rpx;
  color: #ffffff;
  background: linear-gradient(105deg, #0d3b67, #1778b9);
  text-align: center;
  line-height: 90rpx;
  position: fixed;
  left: 50%;
  margin-left: -45%;
  bottom: 20rpx;
  border-radius: 90rpx;
  box-sizing: border-box;
}

.percent_wrap {
  display: flex;
  align-items: center;
  margin-top: 80rpx;
}

.percent_num {
  font-size: 23rpx;
  font-family: PingFang;
  font-weight: 500;
  color: #483311;
}

.content_list_line {
  height: 6rpx;
  background-color: #e9eaee;
  border-radius: 100rpx;
  width: 100%;
}

.content_list_line_bili {
  width: 86%;
  height: 100%;
  background-color: #1769b0;
  border-radius: 100rpx;
  background: #1769b0;
}

.product_ld {
  width: 80%;
  height: 80rpx;
  margin: 0 auto;
}

.list {
  display: flex;
  flex-direction: row;
  height: 120rpx;
  width: 690rpx;
  margin: 0 auto;
  border-radius: 10rpx;
  margin-top: 8rpx;
  margin-bottom: 80rpx;
  position: relative;
  z-index: 1;
}

.list_1 {
  display: flex;
  flex-direction: row;
  height: 100rpx;
  width: 660rpx;
  margin: 0 auto;

  margin-bottom: 0rpx;
  position: relative;
  z-index: 1;
}

.line {
  width: 660rpx;
  height: 1rpx;
  background-color: #e5e5e5;
}

.list_1_left {
  height: 100%;
  line-height: 100rpx;
  color: #999999;
  font-size: 24rpx;
  font-weight: 500;
}

.list_1_right {
  height: 100%;
  line-height: 100rpx;
  padding-left: 80rpx;
  font-size: 24rpx;
  font-weight: 500;
}

.list .list_item {
  flex: 1;
  height: 120rpx;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.list_item_top,
.list_item_bottom {
  text-align: center;
}

.list_item_bottom {
  font-size: 24rpx;
  font-family: PingFangSC;
  font-weight: 500;
  color: #000000;
  margin-top: 10rpx;
}

.list_item_img {
  width: 80rpx;
  height: 80rpx;
}

.ques_title uni-text {
  background: linear-gradient(#ef7436, #f96820);
}

.ques_answer uni-text {
  background: linear-gradient(#4d4a48, #2c2927);
}
::v-deep {
  .van-tabs__line {
    background-color: var(--bg-color);
  }
}
.aaa-dc {
  background: #f5f5f8;
  border-radius: 5px;
  line-height: 35px;
  font-size: 12px;
  margin-top: 10px;
  padding-left: 10px;
}
.desc-sll p {
  font-size: 13px;
  font-family: Microsoft YaHei;
  color: #000;
  line-height: 20px;
  font-weight: 400;
  border-radius: 8px;
  padding: 10px;
  background-color: #f7f7f7;
  margin-bottom: 10px;
}
</style>

